import { createSlice } from "@reduxjs/toolkit";
import {getPlatformNameOrId} from "../../../helpers/getPlatformName"

export const filterSlice = createSlice({
  name: "Filter",
  initialState: {
    filter_platform: {
      value: "all",
      label: "All",
    },
    filter_campaign_status: {
      value: null,
      label: "All",
    },
    filter_campaign: {
      value: null,
      label: "All",
    },
    filter_date_range: {
      days: {
        value: null,
        label: "All Time",
      },
      startDate: null,
      endDate: null,
    },
    filter_ads_platform:{
      value:null,
      label:"All"
    },
    filter_ads_selected_platform:{
      platform_id:null,
      socialMediaType:null,
      accountDetails:null
    },
    select_organic_social_platform:{
       platform_id:2,
       platform_name:getPlatformNameOrId(2),
        socialMediaType:null,
      accountDetails:null

    }

  },
  reducers: {
    UPDATE_FILTER_DATA: (state, action) => {
      return { ...state, ...action?.payload };
    },
    CLEAR_FILTER_DATA: (state, action) => {
      return {  };
    },
  },
});

export const { UPDATE_FILTER_DATA,CLEAR_FILTER_DATA } = filterSlice.actions;

export default filterSlice.reducer;
